export interface ExternalJob {
  id: string;
  action: string;
  status: 'queued' | 'running' | 'succeeded' | 'failed';
}
/** History is newest first. An acknowledgement is never evidence of completion. */
export function externalSyncStatus(
  jobs: readonly ExternalJob[],
  acknowledgedId: string | null,
  unavailable: boolean,
): ExternalJob['status'] | 'unknown' | null {
  if (unavailable) return 'unknown';
  if (
    acknowledgedId &&
    !jobs.some((entry) => entry.action === 'sync' && entry.id === acknowledgedId)
  )
    return 'unknown';
  return jobs.find((entry) => entry.action === 'sync')?.status ?? null;
}
